import {
  createCsrfMiddleware,
  createMiddleware,
  createStart,
} from "@tanstack/react-start"
import { compressPublicHtml } from "./lib/compress-public-html"

const landingCompression = createMiddleware().server(
  async ({ request, next }) => {
    const result = await next()
    if (new URL(request.url).pathname !== "/") return result
    return { ...result, response: compressPublicHtml(request, result.response) }
  }
)

export const startInstance = createStart(() => ({
  requestMiddleware: [
    createCsrfMiddleware({
      filter: (context) => context.handlerType === "serverFn",
    }),
    landingCompression,
  ],
}))
